import { ReportDownloadRequest } from '@linka/domain/requests';
import { eventDashboardController } from './controller';

export const eventDashboardMutations = {
  requestDownload: (eventId: string) => ({
    mutationFn: (data: ReportDownloadRequest) =>
      eventDashboardController.requestDownload(data, { urlParams: { eventId } }),
  }),
  downloadFile: () => ({
    mutationFn: async ({ eventId, exportId }: { eventId: string; exportId: string }) => {
      const response = await eventDashboardController.downloadFile({
        urlParams: { eventId, exportId },
        responseType: 'blob',
      });

      if (!response?.data) throw new Error('Failed to download file');

      const contentDisposition = response.headers['content-disposition'] as string | undefined;
      let fileName = 'downloaded-file';

      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?([^"]+)"?/);
        if (match?.[1]) fileName = match[1];
      }

      const blob = response.data instanceof Blob ? response.data : new Blob([response.data as BlobPart]);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    },
  }),
};
